import React from 'react';
import { Headphones, Heart, Building2, Store, GraduationCap, Users, Truck, Briefcase, Cloud } from 'lucide-react';

const ExchangeIndustries = () => {
  const industries = [
    { icon: Headphones, name: 'Call & Contact Centers', path: '/solutions/call-centers' },
    { icon: Heart, name: 'Healthcare Systems', path: '/solutions/healthcare' },
    { icon: Building2, name: 'Banks & Credit Unions', path: '/solutions/banks-credit-unions' },
    { icon: Store, name: 'Franchise & Multi-Unit Organizations', path: '/solutions/franchise' },
    { icon: GraduationCap, name: 'Education (Staff & Operations)', path: '/solutions/education' },
    { icon: Truck, name: 'Logistics & Trucking', path: '/solutions/logistics-trucking' },
    { icon: Briefcase, name: 'Staffing & Recruiting Centers', path: '/solutions/staffing-recruiting' },
    { icon: Users, name: 'Consultants & Training Organizations', path: '/solutions/consultants-trainers' },
    { icon: Cloud, name: 'Technology Platforms & Cloud Marketplaces', path: '/solutions/technology-platforms' }
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
            Designed for <span className="text-cyan-400">High-Impact Organizations</span>
          </h2>
          <p className="text-xl text-gray-300">
            Traain Exchange provides ready-to-deploy training for teams where performance matters:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {industries.map((industry, index) => {
            const Icon = industry.icon;
            return (
              <a
                key={index}
                href={industry.path}
                className="flex items-center gap-4 p-5 rounded-xl bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 hover:border-cyan-500/50 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 group"
              >
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <Icon className="w-5 h-5 text-cyan-400" />
                </div>
                <p className="text-gray-300 group-hover:text-white transition-colors">{industry.name}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ExchangeIndustries;
